import { PropsWithChildren } from 'react';
import { Footer } from './footer';
import { Header, HeaderProps } from './header';

type PageLayoutProps = { header?: HeaderProps } & PropsWithChildren;

export const PageLayout = ({ children, header }: PageLayoutProps) => {
  return (
    <div>
      <Header {...header} />
      <main className="min-h-[70vh] flex flex-col justify-center items-center px-8">
        {children}
      </main>
      <Footer />
    </div>
  );
};
